import { render, staticRenderFns } from "./refund-serve.vue?vue&type=template&id=e450ef88&scoped=true"
import script from "./refund-serve.vue?vue&type=script&lang=js"
export * from "./refund-serve.vue?vue&type=script&lang=js"
import style0 from "./refund-serve.vue?vue&type=style&index=0&id=e450ef88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e450ef88",
  null
  
)

export default component.exports